import React, { Component } from 'react';
import Moment from 'moment';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import { fetchAuthenticatedConsultNote } from '../../services/api';

class ConsultNote extends Component {
  state = {
    consultNote: {},
    isLoading: true,
    hasError: false,
  };

  async componentDidMount() {
    const { token } = this.props.match.params;
    if (!token) {
      window.location.href = process.env.REACT_APP_HOMEPAGE_URL;
      return;
    }

    try {
      this.setState({ isLoading: true, hasError: false });
      const consultNote = await fetchAuthenticatedConsultNote(token);
      this.setState({ consultNote });
    } catch (err) {
      console.error(err);
      this.setState({ hasError: true });
    } finally {
      this.setState({ isLoading: false });
    }
  }

  render() {
    const { classes } = this.props;
    const { consultNote, hasError } = this.state;

    return (
      <Grid
        container
        alignItems="center"
        direction="column"
        classes={{ container: classes.container }}
      >
        <Grid item xs={12} md={8} lg={6}>
          <Grid container>
            {hasError && (
              <Grid item xs={12} classes={{ item: classes.error }}>
                <span>
                  Error fetching note. Please try again by refreshing the page.
                </span>
              </Grid>
            )}

            <Grid item xs={12} classes={{ item: classes.text }}>
              <Typography variant="body1" classes={{ root: classes.bodyText }}>
                This consult comes to you courtesy of a Qwell premium provider.
                Qwell is a HIPAA secure platform that connects patients to
                doctors and doctors to each other. Qwell is used by growing
                numbers of doctors to help them book more appointments online,
                refer patients to other doctors in their network, and
                communicate easily with other doctors about their patients. By
                creating an online medical home for our patients, Qwell brings
                you the patients that will benefit most from your care - whether
                they find you online or are sent to you by another doctor.
              </Typography>

              <Typography variant="body1" classes={{ root: classes.bodyText }}>
                You may view this message below courtesy of Qwell. To
                access Qwell's enhanced capabilities you are invited to join our
                Premium membership by clicking:{' '}
                <a href={process.env.REACT_APP_HOMEPAGE_URL + '/sign-up/'}>
                  {process.env.REACT_APP_HOMEPAGE_URL + '/sign-up/'}
                </a>
                .
              </Typography>
            </Grid>

            <Grid item xs={12} classes={{ item: classes.group }}>
              <Typography variant="h3" classes={{ root: classes.headingText }}>
                Patient Name:
              </Typography>

              <Typography variant="h2" classes={{ root: classes.answerText }}>
                {consultNote.patientName || 'N/A'}
              </Typography>
            </Grid>

            <Grid item xs={12} classes={{ item: classes.group }}>
              <Typography variant="h3" classes={{ root: classes.headingText }}>
                Patient DOB:
              </Typography>

              <Typography variant="h2" classes={{ root: classes.answerText }}>
                {consultNote.patientDOB || 'N/A'}
              </Typography>
            </Grid>

            <Grid item xs={12} classes={{ item: classes.group }}>
              <Typography variant="h3" classes={{ root: classes.headingText }}>
                From (Provider):
              </Typography>

              <Typography variant="h2" classes={{ root: classes.answerText }}>
                {consultNote.fromProviderName || 'N/A'}
              </Typography>
            </Grid>

            <Grid item xs={12} classes={{ item: classes.group }}>
              <Typography variant="h3" classes={{ root: classes.headingText }}>
                Note:
              </Typography>

              <Typography variant="h2" classes={{ root: classes.answerText }}>
                {consultNote.body || 'N/A'}
              </Typography>
            </Grid>

            <Grid item xs={12} classes={{ item: classes.group }}>
              <Typography variant="h3" classes={{ root: classes.headingText }}>
                Sent At:
              </Typography>

              <Typography variant="h2" classes={{ root: classes.answerText }}>
                {consultNote.sentAt
                  ? Moment(consultNote.sentAt).format('MM/DD/YYYY h:mma z')
                  : 'N/A'}
              </Typography>
            </Grid>

            <Grid item xs={12} classes={{ item: classes.text }}>
              <Typography variant="body1" classes={{ root: classes.bodyText }}>
                Sending and receiving messages is one of the many ways
                Qwell helps to strengthen and grow your network while making
                managing your practice easier.{' '}
                <strong>
                  Learn more about what we're doing{' '}
                  <a
                    href={
                      process.env.REACT_APP_HOMEPAGE_URL + '/for-providers/'
                    }
                  >
                    here
                  </a>
                </strong>
                .
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

const styles = () => ({
  container: {
    padding: '3em',
  },
  error: {
    width: '100%',
    backgroundColor: '#FFF6BF',
    marginBottom: '2em',
    color: 'grey',
    padding: '1rem',
    textAlign: 'center',
    border: '1px solid rgba(183,210,229,0.8)',
    borderRadius: '8px',
    boxShadow: 'inset 0 -1px 0 0 #7E95A7, 0 1px 4px 0 rgba(44,64,90,0.21)',
    '@media only screen and (max-width: 1024px)': {
      width: '95%',
    },
  },
  group: {
    paddingTop: '2em',
    paddingBottom: '2em',
  },
  text: {
    padding: '2em 0',
  },
  headingText: {
    fontSize: '1.5em',
    paddingBottom: '0.5em',
  },
  answerText: {
    fontSize: '1.7em',
  },
  bodyText: {
    fontSize: '1.2em',
    paddingBottom: '1em',
  },
});

export default withStyles(styles)(ConsultNote);
